import './SkipLink.scss';

export class SkipLink
{
	static init()
	{
		let html = `
			<a href="#main-content" class="skip-link btn btn-primary btn-sm">
				${BX.message('RS_GOV_SKIP_LINK')}
			</a>
		`;

		document.body.insertAdjacentHTML('afterbegin', html)
	}
}
